export default {"src":"/_next/static/media/flower_faq.8bcdb19b.svg","height":281,"width":178,"blurWidth":0,"blurHeight":0};